function validateEmail(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
}

/* ----- INSTA WIDGET ----- */
/* -- CONFIGS -- */
var bigImgsSize = 30; // <-- Percentagem
/* end CONFIGS - */
function setInstaImgsPosition(widget, widgetPropertys){
	var widgetWidth = widget.width();
	var widgetHeight = widget.height();
	var items = widget.find('div');
	var nrOfItems = items.size();
	var itemPostWidth = widgetWidth / nrOfItems;

	if(nrOfItems > 3){
		var smallImgIndex = 0;
		var bigImg = ':odd';
		items.eq(1).removeClass('small_img_front');
	} else {
		var smallImgIndex = 1;
		var bigImg = ':even';
		items.eq(1).addClass('small_img_front');
	}
	var firstImgHeight = items.eq(smallImgIndex).find('img').height();

	items.each(function(){
		var t = $(this);
		var tIndex = t.index();
		var tWidth = t.width();
		var position = (tIndex * widgetWidth) / nrOfItems;
		t.css({
			width: itemPostWidth,
			left: position
		});
	});
	
	items.filter(bigImg).each(function(){
		var t = $(this);
		var tLeft = parseFloat(t.css('left'));
		var tFinalWidth = t.width() * bigImgsSize/100;
		var tLeftNudge = tFinalWidth / 2;

		var tTop = parseFloat(t.css('top'));
		var tFinalHeight = widgetHeight * bigImgsSize/100;
		var tTopNudge = tFinalHeight / 2;

		t.css({
			width: t.width() + tFinalWidth,
			left: (tLeft - tLeftNudge)
		});

		var tImgHeight = t.find('img').height();
		var bigImgTop = -((tImgHeight - firstImgHeight) / 2);
		if(bigImgsSize === 0){
			bigImgTop = 0;
		}
		t.css({
			top: bigImgTop
		});

		widget.css({
			height: firstImgHeight,
			'margin-top': (Math.abs(bigImgTop) + widgetPropertys.widgetMarginTop),
			'margin-bottom': (Math.abs(bigImgTop) + widgetPropertys.widgetMarginBottom)
		});
	});
}

function startInstaWidget(widgetElement){
	var widget = widgetElement;
	var widgetPropertys = {
		widgetMarginTop: parseFloat(widget.css('margin-top')),
		widgetMarginBottom: parseFloat(widget.css('margin-bottom'))
	}
	setInstaImgsPosition(widget, widgetPropertys);

	$(window).resize(function(){
		setInstaImgsPosition(widget, widgetPropertys);
		setTimeout(function(){
			setInstaImgsPosition(widget, widgetPropertys);
		}, 10);
	});


	var instaImgs = $('.instaimgs_wrapper img');
	var nrOfImgs = 	instaImgs.size();
	var loadedImgs = 0;
	instaImgs.one("load", function() {
		loadedImgs++;
		if(loadedImgs===nrOfImgs){
			setInstaImgsPosition(widget, widgetPropertys);
		}
	}).each(function() {
		if(this.complete) $(this).load();
	});
}
/* --- end INSTA WIDGET --- */


/* ----- cart contents ----- */
function openCloseCart(cartContents, cartContentsState){
	if(cartContentsState=='false'){
		cartContents.stop().fadeIn(300, function(){
			cartContents.attr('data-open', 'true');
		});
	} else {
		cartContents.stop().fadeOut(300, function(){
			cartContents.attr('data-open', 'false');
		});
	}
}

$(function(){
	var myCartBtns = '.btn_mycart a, .btn_mycart_small, #cart-row .btn_mycart, .cart';
	var cartContents = $('.mycart_contents');

	$(document).on('click', myCartBtns, function(e){
		e.preventDefault();
		var cartContentsState = cartContents.attr('data-open');
		openCloseCart(cartContents, cartContentsState);
	});


	$(document).on('click', function(e){
		var target = $(e.toElement);
		if (!target.parents('.mycart_contents').length) {
	        if(!target.parent().hasClass('btn_mycart')) {
	        	var isCartOpen = $('.mycart_contents').attr('data-open');
				if(isCartOpen == 'true'){
					openCloseCart(cartContents, false);
				}
	        }
	    }
	});


	/*$(window).on('scroll', function(){
		var t = $(this);
		var top = t.scrollTop();
		if(top>40){
			$('.mycart_contents_float').css('top', (top+80));
		} else {
			$('.mycart_contents_float').css('top', 105);
		}
	});*/
});


//---------------------------------------------------------
	//-------------------------------------------------------

	//-------------------------------------------------------
	//show the menu on mouse enter
	$(document).on('mouseenter', '.hasmegamenu', function(){

        //return;

		var t = $(this);
		//t.css('border','1px solid #fc0');
		var tMegamenuName = t.attr('data-custommegamenu');
		var tMegamenu = $('#'+tMegamenuName);
		var tMegamenuContent = tMegamenu.find('.megamenu_inner');
		var tMegamenuContentHeight = tMegamenuContent.outerHeight();
		
		//add class to know that mega menu is open
		var isMegaMenuOpen = tMegamenu.hasClass('megamenu_open');

		//animate and add class again?
		tMegamenu.stop().animate({
			height: tMegamenuContentHeight
		}, 200, function(){
			tMegamenu.addClass('megamenu_open');
			is_open = true;
		});

        // force link on dropdown menu
        $(this).on('click', function(){

            window.location= "/surfboards";

        })

	});

	//-------------------------------------------------------

	//-------------------------------------------------------
	//on leave .hasmegamenu
	$(document).on('mouseleave', '.hasmegamenu', function(e){
	//$(document).on('mouseleave', '.megamenu_inner', function(e){				

		//console.log('you left the class .hasmegamenu');
		//console.log('you left the class .megamenu_inner');
		
		var t = $(this);
		var tMegamenuName = t.attr('data-custommegamenu');
		var tMegamenu = $('#'+tMegamenuName);
		//var target = $(e.toElement);
		//var target = $(e.currentTarget);
		//var target = $(e.target);
		//e.relatedTarget 
		//firefox does not recognize toElement..
		var target = $(e.relatedTarget);

		//console.log(target);
		//console.log('tMegamenuName = '+tMegamenuName);
		
		//bug starts here..
		//seems that firefox does not handle well target.parents('div#'+tMegamenuName)
		//on leave the button, if the current target is NOT the current mega menu..
		if (!target.parents('div#'+tMegamenuName).length) {
		//if( $('#'+tMegamenuName).length > 0 ){
		//if( is_open === true ){
			
					//console.log( 'parents of target: '+target.parents('div#'+tMegamenuName).length );
			
	        if(!target.hasClass('megamenu')) {
	        	tMegamenu.stop().animate({
							height: 0
						}, 200, function(){
						//what happens here..?	
						tMegamenu.removeClass('megamenu_open');
					}
				);
	    }
	  }

			//on leave .megamenu..? inside on leave .hasmegamenu..?		  
	    $(document).on('mouseleave', '.megamenu', function(){
				
				//console.log('you left the class .megamenu');
				
	    	var t = $(this);
				var tMegamenuName = t.attr('id');

				$('.hasmegamenu').each(function(){
					var tItem = $(this);
					if(tItem.attr('data-custommegamenu') == tMegamenuName) {
						tItem.removeClass('curr_megamenu');
					}
				});

				tMegamenu.stop().animate({
					height: 0
				}, 200, function(){
					tMegamenu.removeClass('megamenu_open');
				});			
		
			});
		
		//what happerns here..?
		$(document).on('mouseenter', '.megamenu', function(){
			var t = $(this);
			var tMegamenuName = t.attr('id');

			$('.hasmegamenu').each(function(){
				var tItem = $(this);
				if(tItem.attr('data-custommegamenu') == tMegamenuName) {
					tItem.addClass('curr_megamenu');
				}
			});
		});
		
	});//end on leave..?

//---------------------------------------------------------

//show surfboard on mega menu
$(function(){
	
	var boardPreviewWrapper = $('.mmboardpreview'); 
	var boardPreviewTarget = boardPreviewWrapper.find('img');

	function showBoard(boardImg, min_price, model, currency_iso, currency_symbol){		
		
		boardPreviewTarget.attr('src', boardImg);
		boardPreviewWrapper.css(
			{
				'height'	:	'auto',
				'width'		: '400px',
				'left'		:	'100px'
			}
		)
		//boardPreviewWrapper.css('width', '400px');
		//boardPreviewWrapper.css('left', '100px');

		boardPreviewWrapper.find('.mmbp_title').html(model);
		boardPreviewWrapper.find('.mmbp_price_price').html(min_price);
		boardPreviewWrapper.find('.mmbp_price_symbol').html(currency_symbol);
		boardPreviewWrapper.find('.mmbp_price_iso').html(currency_iso);
		
		//boardPreviewWrapper.stop().fadeIn(1000);
		boardPreviewWrapper.stop().animate(
			{
				'opacity':1,
				'left': '0px'
			}, 
			500
		)
	}
	
	function hideBoard(){
		
		//boardPreviewWrapper.stop().fadeOut(500, function(){
		boardPreviewWrapper.stop().animate(
			{
				'opacity':0,
				'left': '50px'
			}, 
			1000,
			function(){
			//boardPreviewWrapper.css('height', 0);
				boardPreviewTarget.attr('src', '');
		})
		
	}
	
	$(document).on('mouseenter', '.megamenu ul li a', function(){
		var t = $(this);
		var boardImg = t.attr('data-boardimg');
		var min_price = t.attr('data-min_price');
		
		var currency_iso = t.attr('data-currencyiso');
		var currency_symbol = t.attr('data-currencysymbol');
		
		var model = t.attr('data-model');
		if(boardImg != undefined && boardImg != ''){
			showBoard(boardImg, min_price, model, currency_iso, currency_symbol);
		}
	});
	
	$(document).on('mouseleave', '.megamenu ul li a', function(){
		hideBoard();
	});
	
});
/* --- end MEGAMENU --- */


/* ----- FEATURED BOARDS WIDGET ----- */
	var itemsPerPage = 3;
	function init_FeaturedBoards(widget){

        //console.log( widget );

		var smallCrossoverPoint = 750;
		var animSpeed = 400;
		var winWPrev = $(window).width();
		var intoSmall = false;
		var smallCurrPageMemory = -1;

		$(window).resize(function(){
			var winW = $(window).width();
			if(winWPrev < winW){
				if(winW > smallCrossoverPoint){
					if(intoSmall==true){
						// ----- small OUT
						itemsPerPage = 3;
						var currPageTemp = Number(widget.find('.featuredboards_viewport').attr('data-currpage'));
						var currPageToSmall = Math.floor(currPageTemp / 3);
						widget.find('.featuredboards_viewport').attr('data-currpage', currPageToSmall);
						intoSmall = false;
						smallCurrPageMemory = currPageTemp;
						setBottomNavPages(widget);
						checkCurrBottomNav(widget, currPageToSmall);
					}
				}
			} else {
				if(winW < smallCrossoverPoint){
					if(intoSmall==false){
						// ----- small IN
						itemsPerPage = 1;
						var currPageTemp = widget.find('.featuredboards_viewport').attr('data-currpage');
						var currPageToSmall = currPageTemp * 3;
						if(smallCurrPageMemory > -1){
							widget.find('.featuredboards_viewport').attr('data-currpage', smallCurrPageMemory);
						} else {
							widget.find('.featuredboards_viewport').attr('data-currpage', currPageToSmall);
						}
						intoSmall = true;
						setBottomNavPages(widget);
						checkCurrBottomNav(widget, currPageToSmall);
					}
				}
			}
			winWPrev = winW;

			var currPage = Number(widget.find('.featuredboards_viewport').attr('data-currpage'));
			var mainContainer = widget.find('.fboards_maincontainer');
			var containerWidth = mainContainer.width();
			var track = widget.find('.featuredboards_track');
			var trackGoTo = -(currPage * containerWidth);
			var containerWidth = mainContainer.width();

			track.css({
				'left': trackGoTo
			});

			var windowWidth = $(window).width();
			if(windowWidth < (smallCrossoverPoint+1)){
				// ----- RUN on RESIZE IN
				$('.featb_item').width(containerWidth);
			} else {
				// ----- RUN on RESIZE OUT
				$('.featb_item').attr('style', '');
			}
		});

        $(document).on('click', '.featbnav_next', function(e){

            e.preventDefault();

            $(document).trigger('board_widget_next',['next-nav']);

        })

		//$(document).on('click', '.featbnav_next', function(e){
        // trying to distinguish two events, next and size nav
        $(document).on('board_widget_next', function(e, target){

            //console.log('clicked or triggered next!');

            /*
            console.log('board_widget_next was triggered');
            console.log('e.target: '+e.target);
            console.log('e.currentTarget: '+e.currentTarget);
            console.log('target: '+target);
            */

			e.preventDefault();

            var t = $(this);

            //console.log( t );

			//var mainContainer = t.closest('.fboards_maincontainer');

            var mainContainer = $('.fboards_maincontainer');

			var track = mainContainer.find('.featuredboards_track');

            // getting the currPage from .featuredboards_viewport, but is defined where?
			var currPage = Number(mainContainer.find('.featuredboards_viewport').attr('data-currpage'));
            //var currPage = mainContainer.find('.featuredboards_viewport').attr('data-currpage');

            currPage++;

            //console.log( 'currPage: '+currPage );

			var containerWidth = mainContainer.width();
			//var trackPosition = parseFloat(track.css('left'));

            // the ammount to travel is defined here
			/*
            var trackGoTo = -(currPage * containerWidth);
            console.log( 'currPage: '+currPage );
            console.log( 'containerWidth: '+containerWidth );
            console.log( 'trackGoTo: '+trackGoTo );
            */

            // PBS a possible solution:
            // get the position of the next separator and travel that..?
            // but it will not work for normal "next".. or maybe it will because it� based on the currPage
            // it doesn�t work..
            // try to catch the event trigger and handle it

            //console.log( $('.featbsep_'+currPage).position() );

            //console.log( 'searching for $(".featbsep_'+currPage * 2+'" )' );

            if( target == 'wave-size-nav'){

                // get the selected wave size
                $next_separator = $('.fbbn_curr').data('separator');

                //console.log( '$next_separator: '+$next_separator );

                var position_of_next_separator = $('.featbsep_'+$next_separator ).position();

                //console.log( position_of_next_separator.left );

                var trackGoTo = -position_of_next_separator.left;

            }else{

                //console.log('the target was next arrow..');
                var trackGoTo = -(currPage * containerWidth);

            }


			var nrOfItems = track.find('.featb_item').size();
			var totalPages = Math.ceil(nrOfItems / itemsPerPage);
			var lastPage = totalPages - 1;
			var windowW = $(window).width();

            // back 2 the start
			if(currPage > lastPage){
				//console.log('ol�!');
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', lastPage);
				trackGoTo = -(lastPage * containerWidth);
			} else {

                //console.log('here doing stuff..?');

                //alert( currPage );
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', currPage);
                //mainContainer.find('.featuredboards_viewport').attr('data-currpage', 3);

				track.stop().animate({
					left: trackGoTo
				}, animSpeed);

				widget.find('.featb_regua').stop().animate({
					'background-position': -(windowW)
				}, animSpeed, function(){
					widget.find('.featb_regua').css('background-position', 'center');
				});
			}

            smallCurrPageMemory = -1;

            checkCurrBottomNav(widget, currPage );
            // skips the separator as Gon�alo suggested
            //checkCurrBottomNav(widget, currPage - 1 );

		});

        // PBS: maybe try to reuse the code of next..?
		$(document).on('click', '.featbnav_prev', function(e){

            e.preventDefault();

            //return;

			var t = $(this);
			var mainContainer = t.closest('.fboards_maincontainer');
			var track = mainContainer.find('.featuredboards_track');
			var currPage = Number(mainContainer.find('.featuredboards_viewport').attr('data-currpage'));
			currPage--;
			var containerWidth = mainContainer.width();
			var trackPosition = parseFloat(track.css('left'));
			var trackGoTo = -(currPage * containerWidth);
			var windowW = $(window).width();
			
			if(currPage < 0){
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', 0);
				trackGoTo = 0;
			} else {
				mainContainer.find('.featuredboards_viewport').attr('data-currpage', currPage);
				track.stop().animate({
					left: trackGoTo
				}, animSpeed);

				widget.find('.featb_regua').stop().animate({
					'background-position': (windowW)
				}, animSpeed, function(){
					widget.find('.featb_regua').css('background-position', 'center');
				});
			}
			smallCurrPageMemory = -1;

            checkCurrBottomNav(widget, currPage );
            // skips the separator as Gon�alo suggested
            //checkCurrBottomNav(widget, currPage - 1);

		});

		
		//$(document).on('click', '.featb_bottomnav ul li a', function(e){
        $(document).on('click', '.featb_bottomnav ul li', function(e){

            //console.log('here be scrolling..');

			e.preventDefault();

            //return;

			//var t = $(this);
            var tParent = $(this);

            //console.log( t );

			//var tParent = t.closest('li');

            // Get the index of the clicked <li> element, relative to its siblings
			var tIndex = tParent.index();

            //console.log( 'tIndex is: '+tIndex );
            //console.log( tParent );

            //console.log('items per page: '+itemsPerPage);

            // counting from zero
			//var targetIndex = tIndex-1;
            // or maybe NOT!
            var targetIndex = tIndex;

            // get the corresponding separator to get the index
			var targetElement = widget.find('.featuredboards_track .featb_sep').eq(targetIndex);

            //targetElement.css('border','1px dotted orange')

            //console.log( targetElement );

			var elementIndex = targetElement.index();

            //console.log( 'elementIndex (separator) is: '+elementIndex );

            var elementPage = (Math.floor(elementIndex / itemsPerPage))-1;
            //var elementPage = (Math.floor(elementIndex / itemsPerPage));

            // if not currently selected
			if(!tParent.hasClass('fbbn_curr')){

                // remove the currently selected one
				widget.find('.fbbn_curr').removeClass('fbbn_curr');

				tParent.addClass('fbbn_curr');

                //console.log( 'elementPage: '+elementPage );

				//if( tIndex != 0 ){
					//widget.find('.featuredboards_viewport').attr('data-currpage', elementPage - 1 );
                    widget.find('.featuredboards_viewport').attr('data-currpage', elementPage );
				//} else {
					//widget.find('.featuredboards_viewport').attr('data-currpage', -1);
				//}

                // triggers the click on the navigation bar
                //widget.find('.featbnav_next').trigger('click');
                $(document).trigger('board_widget_next',['wave-size-nav']);

			}else{

                console.log("it is already the choosen one.");

            }

		})

		function setBottomNavPages(widget){

			var sepIndex = 0;

            //console.log('setting the corrspage on the size nav');

			widget.find('.featb_bottomnav li').eq(0).attr('data-corrspage', '0');

            // get the separators
            widget.find('.featuredboards_track .featb_sep').each(function(){

                //console.log('looping thru the separatorz');

                // the separator itself
				var t = $(this);

                //console.log( t );

				var tIndex = t.index();
				var tPage = (Math.floor(tIndex / itemsPerPage));

                //console.log( 'tPage = '+tPage );

				widget.find('.featb_bottomnav li').eq(sepIndex).attr('data-corrspage', tPage);

				sepIndex++;

			});

		}

		setBottomNavPages(widget);

		function checkCurrBottomNav(widget, currPage){

            //return;

            //console.log( 'checking nav for currPage:'+currPage );

			var pageFirst = widget.find('.featb_bottomnav ul li').eq(0).attr('data-corrspage');
			var pageSecond = widget.find('.featb_bottomnav ul li').eq(1).attr('data-corrspage');
			var pageThird = widget.find('.featb_bottomnav ul li').eq(2).attr('data-corrspage');
			if(currPage >= pageThird){
				widget.find('.featb_bottomnav ul li.fbbn_curr').removeClass('fbbn_curr');
				widget.find('.featb_bottomnav ul li').eq(2).addClass('fbbn_curr');
			} else if(currPage < pageThird){
				if(currPage < pageSecond){
					widget.find('.featb_bottomnav ul li.fbbn_curr').removeClass('fbbn_curr');
					widget.find('.featb_bottomnav ul li').eq(0).addClass('fbbn_curr');
				} else {
					widget.find('.featb_bottomnav ul li.fbbn_curr').removeClass('fbbn_curr');
					widget.find('.featb_bottomnav ul li').eq(1).addClass('fbbn_curr');
				}
			}
		}

		$(window).resize();
	}

	//what is this?
	$(function(){
		//var widget = $('.featuredboards_home');
		//init_FeaturedBoards(widget);
	});

/* --- end FEATURED BOARDS WIDGET --- */


/* ----- SHOP ONLINE HOME INIT ----- */
$(function(){
	function checkContainerHeight(widget){
		var rowI = 0;
		widget.find('.shponl_tabs .row').each(function(){
			var t = $(this);
			if((rowI%2) === 1){
				t.addClass('row_odd');
			}
			rowI++;
		});
		widget.find('.shponl_nav a:eq(0)').tab('show');
	}

	var widget = $('.shoponline_home');
	checkContainerHeight(widget);
});
/* --- end SHOP ONLINE HOME INIT --- */


/* ------- BOARDS LIST NAV ------- */
$(function(){
	function checkChecked(t){
		var state = t.prop('checked');
		var parent = t.closest('label');
		if(state === true){
			parent.addClass('sblf_checked');
		} else {
			parent.removeClass('sblf_checked');
		}
	}
	$(document).on('change', '.sblf_tabs label input.sblf_filtercheck', function(){
		var t = $(this);
		checkChecked(t)
	});
	$('.sblf_tabs label input.sblf_filtercheck').each(function(){
		var t = $(this);
		checkChecked(t);
	});
});
/* ----- end BOARDS LIST NAV ----- */


/* ------- OTHER BOARDS WIDGET ------- */
	function otherBoardsInit(widget){
		var itemsPerPageSmall = 3;
		var itemsPerPageLarge = 6;

		var win = $(window);
		var bulletsWrapper = widget.find('.carousel-indicators');
		var boardsWrapper = widget.find('.carousel-inner');
		var initialWinW = win.width();
		var winWPrev = initialWinW;
		var smallCrossoverPoint = 750;
		var isSmall;
		if(initialWinW <= smallCrossoverPoint){
			isSmall = false;
			winWPrev++;
		} else {
			isSmall = true;
		}

		function setBoardsColumns(currItemsPerPage){
			var allBoards = widget.find('.os_imgwrapper');
			var nrOfBoards = allBoards.size();
			var nrOfPages = Math.ceil(nrOfBoards / currItemsPerPage);
			var colsValue = 12 / currItemsPerPage;

			bulletsWrapper.empty();
			boardsWrapper.empty();

			for(i=0;i<nrOfPages;i++){
				boardsWrapper.append('<div class="item boardspage"><div class="row"></div></div>');
				bulletsWrapper.append('<li data-target="#othersurfboards_widget" data-slide-to="'+i+'"></li>');
			}
			widget.find('.carousel-indicators li:first').addClass('active');
			widget.find('.boardspage:first').addClass('active');

			widget.find('.boardspage').each(function(){
				var t = $(this);
				for(i=0;i<currItemsPerPage;i++){
					t.find('.row').append('<div class="col-xs-'+colsValue+' boardspage_items"></div>');
				}
			});

			var bpIndex = 0;
			$('.boardspage_items').each(function(){
				var t = $(this);
				t.append(allBoards.eq(bpIndex));
				bpIndex++;
			});
		}

		$(window).resize(function(){
			var winW = win.width();
			if(winW < winWPrev){
				if(winW <= smallCrossoverPoint){
					if(isSmall==false){
						isSmall = true;
						setBoardsColumns(itemsPerPageSmall);
						widget.removeClass('os_large');
						widget.addClass('os_small');
					}
				}
			} else {
				if(winW > smallCrossoverPoint){
					if(isSmall==true){
						isSmall = false;
						setBoardsColumns(itemsPerPageLarge);
						widget.removeClass('os_small');
						widget.addClass('os_large');
					}
				}
			}
			winWPrev = winW;
		});
		$(window).resize();
	}
/* ----- end OTHER BOARDS WIDGET ----- */

//aligns the chilli logo and stuff on the shop home
// i think this was replaced by CSS..
$(function(){
	var linksDstk = $('.links_destaque');
	//var logo = linksDstk.find('.centerlogo_gfx');
	var logo = $('.centerlogo_gfx');
	var logoImg = logo.find('img');

	function setlinksDstkVCenter(){
		var linksDstkH = linksDstk.height();

		//console.log( linksDstkH );

		var logoH = logo.height();
		var logoPos = ((linksDstkH/2) - (logoH/2));
		//logo.css('top', logoPos);
		logo.css('margin-top', logoPos);
	}

	$(window).resize(function(){
		setlinksDstkVCenter();
	});

	logoImg.one("load", function() {
		setlinksDstkVCenter();

		setTimeout(function(){
			setlinksDstkVCenter();
		}, 100);
		setTimeout(function(){
			setlinksDstkVCenter();
		}, 800);
	}).each(function() {
		if(this.complete) $(this).load();
	});
});

/* ------------------ VIDEOS ---------------------- */
function setVideoProperties(){
	$('.vc_item').each(function(){
		var t = $(this);
		var videoSource = t.attr('data-videosource');
		var id = t.attr('data-id');

        console.log('received id: '+id);

		if(videoSource == 'vimeo'){
			$.ajax({
				url: 'https://vimeo.com/api/v2/video/'+id+'.xml',
				method: 'GET',
				context: document.body
			}).done(function(data) {
				var data = $(data);

                // PBS 07.2016: all titles now come from shaperbuddy now
				//var title = data.find('title').text();
                //t.find('.vci_title').text(title);

                var thumb = data.find('thumbnail_large').text();

				t.find('.vci_img > img').attr('src', thumb);
			});
		} else {
			var thumb = 'https://img.youtube.com/vi/'+id+'/0.jpg';
			t.find('.vci_img > img').attr('src', thumb);
		}
	});


	var firstUrl = $('.vc_item:first').attr('href');
	var firstSource = $('.vc_item:first').attr('data-videosource');
	setVideo(firstUrl, firstSource, true);
}


function setVideo(url, videoSource, isFirstVideo){
	
	//console.log(url);
	//assign url to social share
	$('.social-share-video-link').each(function(){
		console.log($(this).data('url'));
        this.href = '';
		//initial_href = this.href;
        initial_href = $(this).data('url')
		final_href = initial_href += url;
		this.href = final_href;
	});
	
	if(videoSource == 'vimeo'){
		if(!isFirstVideo){
			var autoPlayHtml = '?autoplay=true';
		} else {
			var autoPlayHtml = '';
		}
		$('#videomain_wrapper').html('<iframe src="'+url+''+autoPlayHtml+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
	} else {
		if(!isFirstVideo){
			var autoPlayHtml = '?autoplay=1';
		} else {
			var autoPlayHtml = '';
		}
		var youtuId = youtube_parser(url);
		$('#videomain_wrapper').html('<iframe src="https://www.youtube.com/embed/'+youtuId+''+autoPlayHtml+'" frameborder="0" allowfullscreen></iframe>');
	}
}


function setVideoPagination(widget){
	var itemsPerPage = widget.attr('data-itemsperpage');
	var listWrapper = widget.find('.carousel-inner');
	var indicatorsWrapper = widget.find('.carousel-indicators');
	var allItems = widget.find('.vc_item_wrapper');
	var nrOfItems = allItems.size();
	var nrOfPages = Math.ceil(nrOfItems/itemsPerPage);
	listWrapper.empty();
	indicatorsWrapper.empty();

	for(i=0;i<nrOfPages;i++){
		listWrapper.append('<div class="item"><div class="container"><div class="row"></div></div></div>');
	}
	listWrapper.find('.item:first').addClass('active');

	var aiI = 1;
	allItems.each(function(){
		var t = $(this);
		var currPage = Math.ceil(aiI/itemsPerPage);
		listWrapper.find('.item').eq(currPage-1).find('.container > .row').append(t);
		aiI++;
	});

	for(i=0;i<nrOfPages;i++){
		indicatorsWrapper.append('<li data-target="#videos_carousel" data-slide-to="'+i+'">'+(i+1)+'</li>');
	}
	indicatorsWrapper.find('li:first').addClass('active');

	if(nrOfPages<2){
		indicatorsWrapper.hide();
		widget.find('.vc_arrows').hide();
	}



	$(document).on('click', '.vc_item', function(e){
		e.preventDefault();
		var t = $(this);
		var url = t.attr('href');
		var videoWrapper = $('#videomain_wrapper');
		var vwPos = videoWrapper.offset().top;
		var videoSource = t.attr('data-videosource');

		if(url!='#'){
			$("html, body").stop().animate({scrollTop:vwPos}, '500', 'swing', function() {
			});

			setVideo(url, videoSource);
		}

		t.closest(widget).find('.vc_item.active').removeClass('active');
		t.addClass('active');
	});
}

$(function(){
	//var widget = $('.videos_carousel');
	//setVideoPagination(widget);
});
/* ---------------- end VIDEOS -------------------- */


function checkOutDescWidth(){

    //PBS: maybe just use media queries??

    /*$(window).on('resize', function(){
		$('.cpl_item').each(function(){
			var t = $(this);
			var colWidth = t.find('.cplh_col2').width();
			var imgWidth = t.find('.cplh_col2 .cpl_img').width();
			var colWidthMinusImg = colWidth-imgWidth;
			t.find('.cpl_productdesc').width(colWidthMinusImg-10);
		});
	});*/
}

$(function(){
	checkOutDescWidth();
});

function youtube_parser(url){
	var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	var match = url.match(regExp);
	if (match && match[2].length == 11) {
	  return match[2];
	} else {
	  //error
	}
}

function getQueryString(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

var allItems;
function setListItemHeight(allItems){
	var imgs = allItems.find('img');
	var nrOfItems = imgs.size();
	var container = allItems.closest('.container');
	var containerWidth;
	var containerWidthPrev;

	function setHeights(){
		allItems.css('height', 'auto');
		var heights = new Array();
		allItems.each(function(){
			var t = $(this);
			var tHeight = t.height();
			heights.push(tHeight);
		});
		var max = Math.max.apply(null, heights);
		allItems.height(max);
	}

	var loadedImgs = 0;
	imgs.one("load", function() {
		loadedImgs++;
		if(loadedImgs===nrOfItems){
			setHeights();
		}
	}).each(function() {
		if(this.complete) $(this).load();
	});

	$(window).resize(function(){
		containerWidth = container.width();
		if(containerWidth != containerWidthPrev){
			setHeights();
		}
		containerWidthPrev = containerWidth;
	});
	
	setHeights();
}

//what is this for?
//it messed up the height of technolgy items
/*
$(function(){
	allItems = new Array('.shopitem', '.sblbl_board', '.tl_item', '.vc_item_wrapper', '.sbbl_item', '.dl_item', '.cdsclmer_item');
	for(var i=0;i<allItems.length;i++){
		var tTarget = $(allItems[i]) 
		var exist = (tTarget.size()>0);
		if(exist){
			setListItemHeight(tTarget);
		}
	}
});
*/

//where?
/* ----- PARALAX SCROLLING BG ----- 
$(document).ready(function(){
   $window = $(window);
   $('section[data-type="background"]').each(function(){
     var $scroll = $(this);              
      $(window).scroll(function() {                           
        var yPos = -($window.scrollTop() / $scroll.data('speed'));
        var coords = '50% '+ yPos + 'px';
        $scroll.css({ backgroundPosition: coords });   
      });
   });
});
document.createElement("section");
/* --- end PARALAX SCROLLING BG --- */

/* ----- SCROLL TO ANCHOR ----- */
$(function() {	
	
  //$('a[href*=#]:not([href=#])').click(function() {
	//apply only to the right element
	$('#slide-to-top').click(function() {				
		
  	var t = $(this);
  	var parentHasNoScroll = t.closest('.noscrollscript').size();
  	if(parentHasNoScroll === 0){
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 1000);
				return false;
			}
		}
  	}

  });
	
});
/* --- end SCROLL TO ANCHOR --- */

/*
$(function() {
  $('a[href*=#]:not([href=#])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});
*/



$(function(){	
	$(document).on('click', '.shopitem .variant_color', function(){
		var t = $(this);
		var dataColor = t.attr('data-colorname');
		var tLinkElement = t.closest('.shopitem').find('a');
		var initUrl = tLinkElement.attr('data-url');
		var finalUrl = initUrl+'&variantcolor='+dataColor;
		tLinkElement.attr('href', finalUrl);
	});
	
	
	$(document).on('click', '.shponlc_prodpic .variant_color', function(){
		var t = $(this);
		var dataColor = t.attr('data-colorname');
		var tLinkElement = t.closest('.shponlc_prodpic').find('a');
		var initUrl = tLinkElement.attr('data-url');
		var finalUrl = initUrl+'&variantcolor='+dataColor;
		tLinkElement.attr('href', finalUrl);
	});
});




/*add border to product variants on click*/

$('body').on('click','.variant_color',function(){
	$('.variant_color_selected').removeClass('variant_color_selected');
	$(this).addClass('variant_color_selected');
})







